module.exports = __webpack_public_path__ + "static/media/emma_03.0731ae68.png";